export const AppConfig = {
    isCurrencyAllowedOnCashPayment: true,
    app_userAgent: {
        android: 'box8-android',
        ios: 'box8-ios',
        common_string: 'box8-webview'
    },
    isSmartBanner: true,
    isBrandRating: true,
    
    cart_version: '2.0.0'
};
